var $e3b2b7128a600af6$exports = {};
$e3b2b7128a600af6$exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`
};


export {$e3b2b7128a600af6$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
